import { store } from "@/store";

// Root domain of the VN site, configurable per environment
const VN_SITE_DOMAIN = process.env.VUE_APP_VN_SITE_DOMAIN || "igsc.edu.vn";

const matchDomain = (domain, rootDomain) => {
  if (!domain || !rootDomain) return false;

  return domain === rootDomain || domain.endsWith(`.${rootDomain}`);
};

// allowed_domain of the school the user signed in to,
// fallback to the domain serving the CMS (ex: school has no allowed_domain yet)
const getSiteDomain = () => {
  const allowedDomain = store && store.getters["schoolAuth/allowedDomain"];

  return allowedDomain || window.location.hostname;
};

const isVnSite = () => matchDomain(getSiteDomain(), VN_SITE_DOMAIN);

// Uuid of the school records using the IGSC branding and report templates,
// must stay in sync with IGSC_SCHOOL_UUIDS on sis-utility-service
const IGSC_SCHOOL_UUIDS = ["igsc"];

const getSchoolUuid = () => {
  const school = store && store.getters["schoolAuth/getSchool"];

  return (
    (school && school.uuid) ||
    (store && store.getters["schoolAuth/getScId"]) ||
    ""
  );
};

// IGSC is matched by the school signed in to, the serving domain is the fallback
const isIgscSchool = () =>
  IGSC_SCHOOL_UUIDS.includes(getSchoolUuid()) || isVnSite();

// Brand logos: IGSC uses its own logo, other schools keep the IGS one
const IGS_LOGO = "/img/igs-logo.png";
const IGSC_LOGO = "/img/igsc-logo.png";

// Icon shown for the IGS apps in the dashboard Learning corner on IGSC
const IGSC_LEARNING_CORNER_ICON = "/img/dashboard/igsc-learning-corner.png";

const getBrandLogo = () => (isIgscSchool() ? IGSC_LOGO : IGS_LOGO);

export {
  isVnSite,
  isIgscSchool,
  IGSC_SCHOOL_UUIDS,
  getSiteDomain,
  matchDomain,
  getBrandLogo,
  VN_SITE_DOMAIN,
  IGS_LOGO,
  IGSC_LOGO,
  IGSC_LEARNING_CORNER_ICON
};
